<template>
  <ODialog ref="dialog" :maxWidth="700" hide-if-loading>
    <v-card v-if="row != null">
      <!-- <ODialogBar
        title="Editar Centro de Custo"
        @close="$refs.dialog.$dismiss()"
      /> -->

      <v-tabs v-model="currentTab" background-color="grey lighten-2">
        <v-tab href="#1">
          <v-badge content="!" color="deep-orange" :value="!tab1valid">
            Geral
          </v-badge>
        </v-tab>
        <v-tab href="#2">
          <v-badge content="!" color="deep-orange" :value="!tab2valid">
            Valores
          </v-badge>
        </v-tab>
        <v-tab href="#3">
          <v-badge content="!" color="deep-orange" :value="!tab3valid">
            Datas
          </v-badge>
        </v-tab>

        <v-tab-item value="1" eager>
          <v-card-text class="pa-3">
            <v-form v-model="tab1valid">
              <div class="h-row-wrap h-row-top children-pa-3">
                <div class="oderon-col-6">
                  <v-text-field v-model="row.name" label="Nome" />
                </div>

                <div class="oderon-col-6">
                  <v-select
                    v-model="row.orgId"
                    label="Organização/Sistema"
                    :items="prdOrgs"
                    item-text="label"
                    item-value="id"
                    hide-details
                  />
                </div>

                <div class="oderon-col-6">
                  <v-select
                    :disabled="readonlyCustomer"
                    v-model="row.customerId"
                    label="Cliente"
                    :items="allCustomers"
                    item-text="label"
                    item-value="id"
                    hide-details
                  />
                </div>

                <div class="oderon-col-6">
                  <v-text-field
                    v-model="row.contractCode"
                    label="Número do Contrato"
                  />
                </div>

                <div class="oderon-col-12">
                  <v-select
                    v-model="row.requiresMeasureApproval"
                    label="Requer Aprovação de Medição"
                    hide-details
                    :items="[
                      {
                        value: false,
                        text:
                          'Não ─ medição pode ser fechada e faturada em seguida'
                      },
                      {
                        value: true,
                        text:
                          'Sim ─ medição precisa passar por aprovador antes de ser faturada'
                      }
                    ]"
                  />
                </div>
              </div>
            </v-form>
          </v-card-text>
        </v-tab-item>

        <v-tab-item value="2" eager>
          <v-card-text class="pa-3">
            <v-form v-model="tab2valid">
              <div class="h-row-wrap h-row-top children-pa-3">
                <div class="oderon-col-6">
                  <OMoneyInput
                    v-model="row.monthlyValue"
                    label="Valor mensalidade"
                  />
                </div>
                <div class="oderon-col-6">
                  <OMoneyInput
                    v-model="row.installValue"
                    label="Valor Instalação"
                  />
                </div>
                <div class="oderon-col-6">
                  <OMoneyInput
                    v-model="row.removeValue"
                    label="Valor Remoção"
                  />
                </div>
                <div class="oderon-col-6">
                  <OMoneyInput
                    v-model="row.cardValue"
                    label="Valor Crachá"
                  />
                </div>
                <div class="oderon-col-6">
                  <v-select
                    v-model="row.paymentMethod"
                    label="Forma de Pagamento"
                    :items="allPaymentMethods"
                  />
                </div>
              </div>
            </v-form>
          </v-card-text>
        </v-tab-item>

        <v-tab-item value="3" eager>
          <v-card-text class="pa-3">
            <v-form v-model="tab3valid">
              <div class="h-row-wrap h-row-top children-pa-3">
                <div class="oderon-col-6">
                  <v-text-field
                    v-model.number="row.referenceDay"
                    :rules="[numbersOnly]"
                    label="Dia de Início do Período"
                    hint="(a fatura vai deste dia até o mesmo dia do mês seguinte)"
                    persistent-hint
                  />
                </div>

                <div class="oderon-col-6">
                  <v-text-field
                    v-model.number="row.invoiceDay"
                    :rules="[numbersOnly]"
                    label="Dia de Faturamento"
                    hint="(este dia, depois do período anterior)"
                    persistent-hint
                  />
                </div>

                <div class="oderon-col-6">
                  <v-text-field
                    v-model.number="row.dueDay"
                    :rules="[numbersOnly]"
                    label="Dia de Vencimento"
                    hint="(este dia, no mês ajustado; vide a seguir)"
                    persistent-hint
                  />
                </div>

                <div class="oderon-col-6">
                  <v-text-field
                    v-model.number="row.monthDelta"
                    :rules="[numbersOnly]"
                    label="Prazo de Vencimento"
                    hint="(em meses; adicionado ao dia de vencimento)"
                    persistent-hint
                  />
                </div>

                <div class="oderon-col-6">
                  <v-text-field
                    v-model="row.contractStartDate"
                    :rules="[validDate]"
                    label="Data de Início do Contrato"
                    persistent-hint
                  />
                </div>
                <div class="oderon-col-6">
                  <v-text-field
                    v-model="row.measureStartDate"
                    :rules="[validDate]"
                    label="Data da Primeira Instalação (Medição 0)"
                    persistent-hint
                  />
                </div>
                <div class="oderon-col-6">
                  <v-text-field
                    v-model.number="row.contractLengthM"
                    :rules="[numbersOnly]"
                    label="Duração do Contrato"
                    hint="(em meses, a partir da data de início)"
                    persistent-hint
                  />
                </div>
              </div>
            </v-form>
          </v-card-text>
        </v-tab-item>
      </v-tabs>

      <ODialogButtons
        class="pa-6"
        :applyDisabled="!allTabsValid"
        txtApply="OK"
        @cancel="$refs.dialog.$dismiss()"
        @apply="$refs.dialog.$apply(row)"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { Org, CostCenter, Customer } from '@/models'
import { hasTag } from 'oderon-commons/src/utils'
import moment from 'moment'

export default {
  components: {
    ODialog: require('oderon-vue/cpts/ODialog').default,
    ODialogButtons: require('oderon-vue/cpts/ODialogButtons').default,
    OMoneyInput: require('oderon-vue/cpts/OMoneyInput').default
  },
  data() {
    return {
      isLoading: true,
      readonlyCustomer: false,
      tab1valid: true,
      tab2valid: true,
      tab3valid: true,
      currentTab: '1',
      errorTabs: new Set(),
      row: null,
      prdOrgs: [],
      allCustomers: [],
      allPaymentMethods: [
        'Dinheiro',
        'Blto Email',
        'Blto Correio',
        'Transf.',
        'C. Debito',
        'C. Credito'
      ],

      validDate: (value) => {
        if (value == null || value.length < 1) return true
        const pattern = /^\d\d\/\d\d\/\d\d\d\d$/
        if (pattern.test(value)) return true
        else return 'Data inválida (formato: dd/mm/aaaa)'
      },

      numbersOnly: (value) => {
        if (value == null) return true
        const pattern = /^\d+$/
        return pattern.test(value) || 'Número inválido (apenas inteiros)'
      }
    }
  },
  computed: {
    allTabsValid() {
      return this.tab1valid && this.tab2valid && this.tab3valid
    }
  },
  methods: {
    open(id, opts = {}) {
      this.id = id
      this.currentTab = '1'
      this.readonlyCustomer = opts.readonlyCustomer
      this.$refs.dialog.$loading(() => this.fetchData(opts))
      return this.$refs.dialog.$open()
    },
    async fetchData(opts = {}) {
      let orgs = await Org.findAll({ mini: true })
      this.prdOrgs = orgs.filter((o) => hasTag(o.extraInfo, 'PRD'))

      this.allCustomers = await Customer.findAll()

      let row = null
      if (this.id == null) {
        row = Object.assign({}, opts.defaults)
      } else {
        row = await CostCenter.findById(this.id)
      }

      if (row.monthlyValue == null) row.monthlyValue = 0
      if (row.installValue == null) row.installValue = 0
      if (row.removeValue == null) row.removeValue = 0
      // if (row.cardValue == null) row.cardValue = 0
      // if (row.dueDay == null) row.dueDay = 30

      let fmt = (x) => {
        if (row[x]) row[x] = moment(row[x]).format('DD/MM/YYYY')
      }

      fmt('contractStartDate')
      fmt('measureStartDate')

      this.row = row
    }
  }
}
</script>

<style></style>
